import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=10e84c06"
import script from "./Empty.vue?vue&type=script&lang=js"
export * from "./Empty.vue?vue&type=script&lang=js"
import style0 from "./Empty.vue?vue&type=style&index=0&id=10e84c06&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports